import '../custom/one_dimension_chart.js.coffee';# Added by Script 
import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.ShareOfVoiceChartView extends Monitoring.Views.Charts.CustomOneDimensionChart

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.share_voice')
    @title_en = I18n.t('monitoring.dashboard.charts.share_voice', {'locale': 'en'})
    settings = {"class":"ShareOfVoiceChartView","type":"pie","dimension":"labels","title": @title ,"crossDimension":"filtered_labels"}
    super($.extend({}, @options, {settings: settings}))
